import React from 'react';

import { useFeatureToggle } from 'platform/utilities/feature-toggles';

import ChatbotErrorBoundary from './components/ChatbotErrorBoundary';
import { Shell } from './shell/Shell';

function Page() {
  const { useToggleValue, useToggleLoadingValue, TOGGLE_NAMES } =
    useFeatureToggle();
  const togglesLoading = useToggleLoadingValue();
  const chatbotDisabled = useToggleValue(TOGGLE_NAMES.vaChatbotDisabled);

  if (togglesLoading) {
    return <va-loading-indicator />;
  }

  if (chatbotDisabled) {
    return (
      <va-alert status="warning" visible data-testid="chatbot-disabled">
        <p className="vads-u-margin-y--0">
          The VA.gov Chatbot is temporarily unavailable while we perform
          maintenance. Thank you for your patience.
        </p>
      </va-alert>
    );
  }

  // Uncaught page errors are no longer forwarded to Datadog (see
  // utils/logging.js), so a render crash inside the chatbot is only reported
  // because this boundary reports it. It renders no fallback -- the outcome is
  // the same blank area React already produces on an uncaught render error.
  return (
    <ChatbotErrorBoundary>
      <Shell />
    </ChatbotErrorBoundary>
  );
}

export default Page;
